import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-category-filter',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './category-filter.component.html',
    styleUrl: './category-filter.component.scss',
})
export class CategoryFilterComponent {
    @Input() public count: number = 0;

    @Input({ required: true }) public id!: string | number;

    @Input() public isActive = false;

    @Input({ required: true }) public name = '';

    @Output() public readonly selected = new EventEmitter<string | number>();

}
